import { TableModalidade } from "./Components/table/TableModalidade";

export const PageComissoesModalidade = () => {
  return <TableModalidade />;
};
